export const groupByProvider = (providers: any) => {
  if (!providers) return;
  const map = new Map<number, any>();

  // waiting for payment (Online) must pay
  // waiting for payment (Online) change to Cash
  // and then complete

  // else use the 4 APIs approve Reject Cancel Complete

  providers?.forEach((item) => {
    if (!map.has(item.serviceProviderId)) {
      map.set(item.serviceProviderId, {
        serviceProviderId: item.serviceProviderId,
        serviceProvider: item.serviceProvider,
        totalPrice: 0,
        totalMedHubPrice: 0,
        totalPriceBefore: 0,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        logTracker: item.logTracker,
        status: item.status,
        code: item.code,
        services: [],
      });
    }

    const providerGroup = map.get(item.serviceProviderId)!;

    providerGroup.totalPrice += item.totalPriceAfterDiscount;
    providerGroup.totalPriceBefore += item.price;
    providerGroup.totalMedHubPrice += item.totalCoveragesAmount || 0;

    providerGroup.services.push({
      id: item.service.id,
      name: item.service.name,
      imageUrl: item.service.imageUrl,
      type: item.service.type,
      code: item.service.code,
      price: item.totalPriceAfterDiscount,
      medHubPrice: item.totalCoveragesAmount || 0,
      priceBefore: item.price,
    });
  });

  return Array.from(map.values());
};
